import { SymbolConfigData } from "@lib/titan2-slingo/dist/api/model/data/SymbolConfigData";
import { SymbolType } from "@lib/titan2-slingo/dist/api/model/enum/SymbolType";
import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { ApiConstants } from "../enum/ApiConstants";
export class WinLineData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            const symbols = this.data.getStringArray(ApiConstants.PROPERTY_SYMBOLS);
            this.symbolType = SymbolConfigData.getSymbol(symbols[0])?.getType() ?? SymbolType.NUMBER;
            this.numberOfSymbols = symbols.length;
            this.amount = this.data.getNumber(ApiConstants.PROPERTY_AMOUNT);
        }
    }
    getAmount() {
        return this.amount;
    }
    getNumberOfSymbols() {
        return this.numberOfSymbols;
    }
    getSymbolType() {
        return this.symbolType;
    }
}
//# sourceMappingURL=WinLineData.js.map